(function () {
    
    var closeVideoSettingsHandler;
    var keyboardEventHandler;
    var resizeEventListener;
    var orientationChangeEventListener;
    let closeAndReopen;
    let imageBasePath = IMAGES_BASEPATH;

    function launchPlayer(options) {
        closeAndReopen = false;
        if(window['dlsAudioPlayer'].player) {
            window['dlsAudioPlayer'].destroyPlayer();
        }

        if(window['dlsVideoPlayer'].player) {
            let closeAndReopenPlyr = true;
            closeAndReopen = true
            window['dlsVideoPlayer'].destroyPlayer(closeAndReopenPlyr);
        }

        const controls = `
            <div class="titlebar">
                <div class="draggable">
                    <button qid="vid-22" class="plyr__control H_Dragger" title="`+options.translations.FOC._COMMON_ACROSS_PAGES.VIDEO.DRAG+`">
                        <img src="assets/img/Horizontal_Drag_White.svg">
                    </button>
                </div>
                <div class="closediv"> 
                    <button qid="vid-0" class="plyr__control" id="close" title="`+options.translations.FOC._COMMON_ACROSS_PAGES.VIDEO.CLOSE+`"> 
                        <i class="nemo-font nemo-cross"></i> 
                    </button> 
                </div> 
            </div>
            <div class="plyr__controls"> 
                <div class="prgrs"> 
                    <div class="plyr__time plyr__time--current" aria-label="`+options.translations.FOC._COMMON_ACROSS_PAGES.VIDEO.CURRENT_TIME+`">00:00</div> 
                    <div class="plyr__progress"> 
                        <input qid="vid-2" style="color:#ffffff;" data-plyr="seek" type="range" min="0" max="100" step="0.01" value="0" aria-label="`+options.translations.FOC._COMMON_ACROSS_PAGES.VIDEO.SEEK+`"> 
                        <progress class="plyr__progress__buffer" min="0" max="100" value="0">% buffered</progress> 
                        <span role="tooltip" class="plyr__tooltip">00:00</span> 
                    </div> 
                    <div class="plyr__time plyr__time--duration" aria-label="`+options.translations.FOC._COMMON_ACROSS_PAGES.VIDEO.DURATION+`">00:00</div> 
                </div> 
                <div class="ctrls mt-2"> 
                    <button qid="vid-3" type="button" class="plyr__control" data-plyr="captions" id="subs"> 
                        <img src="assets/img/captions_new_white.svg" id="subsInactive" title="`+options.translations.FOC._COMMON_ACROSS_PAGES.VIDEO.ENABLE_SUBTITLES+`">
                        <img src="assets/img/captions_fill.svg" id="subsActive" title="`+options.translations.FOC._COMMON_ACROSS_PAGES.VIDEO.DISABLE_SUBTITLES+`">
                    </button>  
                    <button qid="vid-6" type="button" class="plyr__control bw5" id="rewind" title="`+options.translations.FOC._COMMON_ACROSS_PAGES.VIDEO.REWIND+`"> 
                        <i class="nemo-font nemo-refresh"></i> 
                        <span class="textinrew">-5s</span> 
                    </button> 
                    <button qid="vid-7" type="button" class="plyr__control playpause" aria-label="Play" data-plyr="play"> 
                        <div class="icon--pressed"><span class="glyph" title="`+options.translations.FOC._COMMON_ACROSS_PAGES.VIDEO.PAUSE+`"><i class="fa fa-pause" aria-hidden="true"></i></span></div> 
                        <div class="icon--not-pressed"><span class="glyph" title="`+options.translations.FOC._COMMON_ACROSS_PAGES.VIDEO.PLAY+`"><i class="fa fa-play" aria-hidden="true"></i></span></div> 
                    </button> 
                    <button qid="vid-8" type="button" class="plyr__control fw5" id="forward" title="`+options.translations.FOC._COMMON_ACROSS_PAGES.VIDEO.FORWARD+`"> 
                        <i class="nemo-font nemo-refresh"></i> 
                        <span class="textinfwd">+5s</span>
                    </button> 
                    <button qid="vid-4" type="button" class="plyr__control" id="transcript"> 
                        <img src="assets/img/transcripts_new_white.svg" id='transInactive' title="`+options.translations.FOC._COMMON_ACROSS_PAGES.VIDEO.ENABLE_TRANSCRIPTS+`">
                        <img src="assets/img/transcripts_fill.svg" id='transActive' title="`+options.translations.FOC._COMMON_ACROSS_PAGES.VIDEO.DISABLE_TRANSCRIPTS+`">
                    </button> 
                    <button qid="vid-10" type="button" class="plyr__control setting" data-plyr="settings" id="sets" title="`+options.translations.FOC._COMMON_ACROSS_PAGES.VIDEO.SETTINGS+`"> 
                        <i class="nemo-font nemo-settings"></i> 
                    </button> 
                    <div class="setting-section"> 
                        <div class="setting-container" id="setting-container"> 
                          <div class="volume-control-video-container"> 
                            <p>`+options.translations.FOC._COMMON_ACROSS_PAGES.VIDEO.VOLUME+`</p> 
                            <div class="volume-container" id="volume-container"> 
                                <span class="volume-icon" aria-label="`+options.translations.FOC._COMMON_ACROSS_PAGES.VIDEO.VOLUME+`"><img src="assets/img/Speaker_Icon.svg" /></i></span> 
                                <input qid="vid-11" class="volume-seekbar" data-plyr="volume" type="range" min="0" max="1" step="0.05" value="1" autocomplete="off" aria-label="`+options.translations.FOC._COMMON_ACROSS_PAGES.VIDEO.VOLUME+`"> 
                            </div> 
                          </div>
                            <p>`+options.translations.FOC._COMMON_ACROSS_PAGES.VIDEO.SPEED+`</p> 
                            <div class="speed-container" id="speed-container"> 
                                <span id="slow-speed" class="speedometer" qid="vid-12">`+ options.translations.FOC._COMMON_ACROSS_PAGES.VIDEO.SLOW + `</span> 
                                <span id="normal-speed" class="speedometer" qid="vid-13">`+ options.translations.FOC._COMMON_ACROSS_PAGES.VIDEO.NORMAL + `</span> 
                                <span id="fast-speed" class="speedometer" qid="vid-14">`+ options.translations.FOC._COMMON_ACROSS_PAGES.VIDEO.FAST+`</span> 
                            </div> 
                            <div class="arrow-down"></div> 
                        </div> 
                    </div> 
                    <div class="fullscreen-toggle-buttons">
                        <button qid="vid-23" class="plyr__control hide" id="exit-fullscreen-video" title="`+options.translations.FOC._COMMON_ACROSS_PAGES.VIDEO.EXIT_FULLSCREEN+`">
                            <img src="assets/img/Shrink.svg">
                        </button>
                        <button qid="vid-24" class="plyr__control" id="enter-fullscreen-video" title="`+options.translations.FOC._COMMON_ACROSS_PAGES.VIDEO.ENTER_FULLSCREEN+`">
                            <i class="nemo-font nemo-fullscreen"></i> 
                        </button>
                    </div>
                </div> 
            </div> 
            <div id="subtitle-section" class="subtitle-section subtitle-section-fullscreen"> 
                <div class="subtitle-container subtitle-container-fullscreen" id="subtitle-container"> 
                    <p id="subtitle" class="subtitle-fullscreen m-0"></p> 
                </div> 
            </div>
            `
        ;
        
        var videoSource = options.basepath+"/"+options.jsonData[options.jsonData.type].path; 
        videoSource = videoSource.replace(/ /g, '%20');

        var captionSource;
        if (options.jsonData.type == 'video-package') {
            captionSource = options.basepath + "/" + options.jsonData[options.jsonData.type].subtitles;
            captionSource = captionSource.replace(/ /g, '%20');
        }

        var videoHTML1 = 
            `<div class='video-container'>
                <div class='video-with-transcripts-component'>
                    <div class='video-without-transcripts-component'>
                        <div class='videoplayer_component'>
                            <video id='video-player' controls playsinline crossorigin='anonymous'>
                                <source src='`+videoSource+`' type='video/mp4' />`;

        let videoHTML2 =
                            `</video>
                        </div>
                    </div>
                    <div id="transcript-id" class="transcript-container" style="display:none"> 
                        <div id="transcript-size-handler" class="transcript-size-button"> 
                            <button class="disable px-3" qid="vid-19" onclick="transcriptSizeChange(false)" id="trans-size-decrease" title="`+options.translations.FOC._COMMON_ACROSS_PAGES.VIDEO.DECREASE_TRANSCRIPT_SIZE+`"><i class="fa fa-minus" aria-hidden="true"></i></button> 
                            <div class="size-text">Aa</div> 
                            <button onclick="transcriptSizeChange(true)" qid="vid-20" class="px-3" id="trans-size-increase" title="`+options.translations.FOC._COMMON_ACROSS_PAGES.VIDEO.INCREASE_TRANSCRIPT_SIZE+`"><i class="fa fa-plus" aria-hidden="true"></i></button> 
                        </div> 
                    </div>
                </div>
            </div>`;

        let videoHTML;
        if (captionSource) {
            let capHTML = `<!-- Captions are optional -->
            <track kind='captions' label='English captions' src='` + captionSource + `' srclang='en' default />`;
            videoHTML = videoHTML1 + capHTML + videoHTML2;
        } else {
            videoHTML = videoHTML1 + videoHTML2;
        }

        const position = { x: 0, y: 0 };
        
        if(options.events.onOpen) {
            options.events.onOpen();
        }
        
        interact('.video-container').draggable({
            allowFrom: ".H_Dragger",
            restrict: {
                restriction: '.content-container',
                elementRect: {top: 0, left: 0, bottom: 1, right: 1}
            },
        }).on('dragmove', function (event) {
            let scaleX = window.getComputedStyle(document.querySelector('.video-container')).transform == 'none' ? 1 : window.getComputedStyle(document.querySelector('.video-container')).transform.match(/-?\d+\.?\d*/g)[0];
            position.x += event.dx / scaleX;
            position.y += event.dy / scaleX;
            event.target.style.transform = "scale("+scaleX+") translate("+position.x+"px, "+position.y+"px)";
        }).on('dragstart', function (event) {
            if(options.events.onDragStart) {
                options.events.onDragStart();
            }
        });

        var overlayContainer = document.querySelector('.overlay-container');
        overlayContainer.innerHTML = videoHTML;
        overlayContainer.classList.add('mobile-video-player');
        var contentContainer = document.querySelector('.content-container');

        

        // Captions button is enabled by-default (workaround)
        localStorage.setItem("plyr", JSON.stringify({'captions':false}));
        const player = new Plyr('#video-player', {seekTime:5 , controls:controls, disableContextMenu:false,  captions: { active: true, language: 'auto', update: false}, fullscreen : { enabled: false } });
        var closePlayer = document.querySelector('#close');

        var subtitleSection = document.getElementById('subtitle-section');
        var subtitleContainer = document.getElementById("subtitle-container");

        subtitleContainer.style.display = 'none';


        var subtitle = document.getElementById('subtitle');
        var isSeeking = false;
        var subtitleEndTime = undefined;
        var playerdiv = document.querySelector('.plyr');
        var subtitleStartTime = undefined; 
        var timestampObject = {};
        var currentCue = {};
        var cueArray = [];

        const videoSpeed = document.getElementById("video-player");
        var openSettings = document.querySelector(".setting");
        var settingContainer = document.getElementById("setting-container");
        var volumeContainer = document.getElementById("volume-container");
        var slowSpeedButton = document.getElementById("slow-speed");
        var normalSpeedButton = document.getElementById("normal-speed");
        var fastSpeedButton = document.getElementById("fast-speed");
        var transcriptButton = document.getElementById("transcript");
        var transcriptSection = document.getElementById("transcript-id");
        const transcript = document.getElementById("video-player");
        var videoContainer = document.querySelector('.video-container');
        var enterFullscreenButton = document.querySelector('#enter-fullscreen-video');
        var exitFullscreenButton = document.querySelector('#exit-fullscreen-video');
        var volumeControlContainer = document.querySelector('.volume-control-video-container');
        var videoWithoutTranscriptsContainer = document.querySelector('.video-without-transcripts-component');
        var videoWithTranscriptsContainer = document.querySelector('.video-with-transcripts-component');
        var transcriptContainer = document.querySelector('.transcript-container');
        var horizontalDragger = document.querySelector('.H_Dragger');
        var titlebar = document.querySelector('.titlebar');
        var lastHideControlsTime = 0;
        var timeAtLaunch = Date.now();

        var plyrCaptions = document.querySelector('.plyr__captions');
        var subtitleButton = document.querySelector('#subs');
        var plyrContainer = document.querySelector('.plyr');
        var showsubs = false;
        var showTranscript = false;
        var isTranscriptInitialized = false;
        var video = document.querySelector('video');
        var showSettings = false;
        var selectedSpeed = 1;
        var speedMap = {
            slow: 0.75,
            normal: 1,
            fast: 1.25
        }
        var volRange;
        var isFullscreen = false;
        var isVideoHeightMoreThanWidth = false;
        var isMetaDataLoaded = false;

        // RegEx to check the expression <hh:mm:ss.sss> in karaoke
        const REforTimestamp = /(<[0-9]{0,2}?:?[0-9]{0,2}:[0-9]{0,2}.?[0-9]{0,3}?>)/;
        const REforHTMLTags = /<\/?([a-z]+) ?[^>]*>/ig;
        const AllowedTags = {
            'b' : 'b',
            'i' : 'i',
            'u' : 'u',
            'span' : 'span',
            'a' : 'a',
            'strong': 'strong'
        }
        var browser = {
            isIE: !!document.documentMode,
            isEdge: window.navigator.userAgent.includes('Edge'),
            isWebkit: 'WebkitAppearance' in document.documentElement.style && !/Edge/.test(navigator.userAgent),
            isIPhone: /(iPhone|iPod)/gi.test(navigator.platform),
            isIos: /(iPad|iPhone|iPod)/gi.test(navigator.platform)
        };
        
        if(browser.isIPhone || browser.isIos){
            volumeControlContainer.style.display = "none";
        }

        var forward = document.querySelector("#forward");
        var rewind = document.querySelector("#rewind");
        rewind.classList.add("disabled");
        
        forward.addEventListener("click", function() {
            if(!forward.classList.contains('disabled')) {
                player.forward(5);
            }
        });
        rewind.addEventListener("click", function() {
            if(!rewind.classList.contains('disabled')) {
                player.rewind(5);
            }
        });

        videoSpeed.addEventListener("play", function () {
            changeSpeed(selectedSpeed);
        });

        openSettings.addEventListener("click", function() {
            showSettings = !showSettings;
            if(showSettings) {
                settingContainer.style.display = "block";
                volumeContainer.children[0].hidden = false; 
                volRange = new RangeTouch('input[data-plyr="volume"]');
                $(".selected-speed").removeClass("selected-speed"); 
                if (selectedSpeed === speedMap.slow) {
                    slowSpeedButton.classList.add("selected-speed");
                } else if (selectedSpeed === speedMap.normal) {
                    normalSpeedButton.classList.add("selected-speed");
                } else {
                    fastSpeedButton.classList.add("selected-speed");
                }             
            } else {
                settingContainer.style.display = "none";
            }
        });

        videoSpeed.addEventListener( "loadedmetadata", function (e) {

            if(this.videoWidth >= this.videoHeight) {
                isVideoHeightMoreThanWidth = false;
            } else {
                isVideoHeightMoreThanWidth = true;
            }

            isMetaDataLoaded = true;

        }, false );

        if(options.jsonData.type!="video") {
            transcriptButton.addEventListener("click", function () {
                toggleTranscript();
            });
        }

        fastSpeedButton.addEventListener("click", function() {
            selectedSpeed = speedMap.fast;
            changeSpeed(selectedSpeed);
            $(".selected-speed").removeClass("selected-speed");
            $("#fast-speed").addClass("selected-speed");
        });

        normalSpeedButton.addEventListener("click", function() {
            selectedSpeed = speedMap.normal;
            changeSpeed(selectedSpeed);
            $(".selected-speed").removeClass("selected-speed");
            $("#normal-speed").addClass("selected-speed");
        });

        slowSpeedButton.addEventListener("click", function() {
            selectedSpeed = speedMap.slow;
            changeSpeed(selectedSpeed);
            $(".selected-speed").removeClass("selected-speed");
            $("#slow-speed").addClass("selected-speed");
        });

        function changeSpeed(value) {
            videoSpeed.playbackRate = value;
        }

        /* transcript handler (show/hide)
            show - if passed, transcript will hide/show depending on its value
                 - if not passed, transcript will toggle
        */
        function toggleTranscript(show) {

            if(!isMetaDataLoaded) {
                return;
            }

            showTranscript = !showTranscript;
            if(show != undefined) {
                showTranscript = show;
            }                          
            var transcriptSection = document.getElementById("transcript-id");
            //var subtitleSection = document.getElementsByClassName("plyr__captions")[0];
            
            if(showTranscript) {

                var timer = 100; // ipad full screen loads a little late, so timer has to increase
                if(navigator.userAgent.match(/iPad/i) != null || navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
                    timer = 1000;
                }

                setTimeout(function() {

                    setTranscriptPosition();


                    // transcript section styles
                    transcriptSection.style.display = "flex";
                }, timer);
                
                transcriptButton.classList.add('active');

            } else {

                
                removeTranscriptPosition();

                if(transcriptSection) {
                    transcriptSection.removeAttribute("style");
                    transcriptSection.style.display = "none" ;
                }            
                transcriptButton.classList.remove('active');
                

                // (Use Case: user disables transcript while subtitles is ON)
                // if(showsubs) {
                //     subtitleSection.style.left = ((plyrContainer.offsetWidth - plyrCaptions.offsetWidth) / 2) + 'px';
                // }  

            }
        }

        function setTranscriptPosition() {

            if(!showTranscript || !player) {
                return;
            }

            // transcripts side by side for devices > 1024
            if(window.innerWidth > 1024) {
                videoContainer.classList.add('transcripts-open-side');
                videoWithTranscriptsContainer.classList.add('transcripts-open-side');
                videoWithoutTranscriptsContainer.classList.add('transcripts-open-side');
                transcriptContainer.classList.add('transcripts-open-side');
                titlebar.classList.add('transcripts-open-side');
                plyrContainer.classList.add('transcripts-open-side');

            } else {

                // transcripts side by side for devices <= 1024 but in landscape mode
                if (window.matchMedia("(orientation: landscape)").matches) {
                    videoContainer.classList.add('transcripts-open-side');
                    videoWithTranscriptsContainer.classList.add('transcripts-open-side');
                    videoWithoutTranscriptsContainer.classList.add('transcripts-open-side');
                    transcriptContainer.classList.add('transcripts-open-side');
                    titlebar.classList.add('transcripts-open-side');
                    plyrContainer.classList.add('transcripts-open-side');

                } else {

                    // transcripts on bottom for devices <= 1024 and portrait mode
                    videoContainer.classList.add('transcripts-open-bottom');
                    videoWithTranscriptsContainer.classList.add('transcripts-open-bottom');
                    videoWithoutTranscriptsContainer.classList.add('transcripts-open-bottom');
                    transcriptContainer.classList.add('transcripts-open-bottom');
                    titlebar.classList.add('transcripts-open-bottom');
                    plyrContainer.classList.add('transcripts-open-bottom');

                    if(isVideoHeightMoreThanWidth) {
                        videoWithoutTranscriptsContainer.classList.add('height-fifty-percent');
                    } else {
                        videoWithoutTranscriptsContainer.classList.add('height-fit-content');
                    }

                }

            }

            if(!isFullscreen) {
                let videoContainerBoundingRect = videoContainer.getBoundingClientRect();
                let contentContainerBoundingRect = contentContainer.getBoundingClientRect();
                
                if(videoContainerBoundingRect.left < contentContainerBoundingRect.left) {
                    position.x += (contentContainerBoundingRect.left - videoContainerBoundingRect.left );
                }else if(videoContainerBoundingRect.right > contentContainerBoundingRect.right) {
                    position.x -= (videoContainerBoundingRect.right - contentContainerBoundingRect.right);
                }
                videoContainer.style.transform = "translate("+position.x+"px, "+position.y+"px)";
            }

        }

        function removeTranscriptPosition() {

            videoContainer.classList.remove('transcripts-open-side');
            videoWithTranscriptsContainer.classList.remove('transcripts-open-side');
            videoWithoutTranscriptsContainer.classList.remove('transcripts-open-side');
            transcriptContainer.classList.remove('transcripts-open-side');
            titlebar.classList.remove('transcripts-open-side');
            plyrContainer.classList.remove('transcripts-open-side');

            videoContainer.classList.remove('transcripts-open-bottom');
            videoWithTranscriptsContainer.classList.remove('transcripts-open-bottom');
            videoWithoutTranscriptsContainer.classList.remove('transcripts-open-bottom');
            videoWithoutTranscriptsContainer.classList.remove('height-fifty-percent');
            videoWithoutTranscriptsContainer.classList.remove('height-fit-content');
            transcriptContainer.classList.remove('transcripts-open-bottom');
            titlebar.classList.remove('transcripts-open-bottom');
            plyrContainer.classList.remove('transcripts-open-bottom');

        }

		function transcriptSizeChange(increase) {
            var transcriptSizeDecrease = document.getElementById("trans-size-decrease");
            var transcriptSizeIncrease = document.getElementById("trans-size-increase");
            if(increase) {
                transcriptSizeDecrease.classList.remove('disable');
                transcriptSizeIncrease.classList.add('disable');
            } else {
                transcriptSizeDecrease.classList.add('disable');
                transcriptSizeIncrease.classList.remove('disable');
            }

            var script = document.getElementsByClassName('cues');
            for(let k = 0; k < script.length; k++) {
                if(script[k].classList.contains('size')) {
                    script[k].classList.remove('size');
                } else {
                    script[k].classList.add('size');
                }
            }
        }
        window.transcriptSizeChange = transcriptSizeChange;

        function reduceTranscriptsSize() {

            var transcriptSizeDecrease = document.getElementById("trans-size-decrease");
            var transcriptSizeIncrease = document.getElementById("trans-size-increase");

            if(transcriptSizeDecrease) {
                transcriptSizeDecrease.classList.add('disable');
            }

            if(transcriptSizeIncrease) {
                transcriptSizeIncrease.classList.remove('disable');
            }

            var cues = document.getElementsByClassName('cues');
            for(let k = 0; k < cues.length; k++) {
                if(cues[k].classList.contains('size')) {
                    cues[k].classList.remove('size');
                }
            }
        }

        overlayContainer.style.display = 'flex';
        closePlayer.addEventListener("click", function(){
            dlsVideoPlayer.destroyPlayer();
        });

        
        player.on('timeupdate', function(){
            var currentTime = parseInt(player.currentTime);
            var duration = parseInt(player.duration);
            
            if(playerdiv.classList.contains("plyr--hide-controls")){
                subtitleSection.style.transform = "translateY(-15px)";
            } else {
                subtitleSection.style.transform = "translateY(-95px)";
            }
            
            //karoake subtitles
            if(currentCue.timeStamp) {
                var currentIndex = 0;
                for(let a=0; a<timestampObject[currentCue.id].length; a++) {
                    var karaokeTime = timestampObject[currentCue.id][a];
                    if(player.currentTime >= karaokeTime) {
                        if(a < timestampObject[currentCue.id].length - 1) {
                            if(player.currentTime >= timestampObject[currentCue.id][a+1]) continue;
                            else {
                                currentIndex = (a+1);
                                break;
                            }
                        } else {
                            currentIndex = timestampObject[currentCue.id].length;
                        }
                    }
                }
                
                var elSubtitles = document.querySelectorAll("#subtitle > span");
                for(let l=0; l< elSubtitles.length; l++) {
                    elSubtitles[l].classList.remove('current-karoake');
                    elSubtitles[l].classList.remove('future-karoake');
                    elSubtitles[l].classList.remove('past-karoake');
                    if(l > currentIndex) {
                        elSubtitles[l].classList.add('future-karoake');
                    } else if (l < currentIndex) {
                        elSubtitles[l].classList.add('past-karoake');
                    } else {
                        elSubtitles[l].classList.add('current-karoake');
                    }
                }
            }

            // rewind disable handling
            if(currentTime == 0) {
                rewind.classList.add("disabled");
            } else {
                rewind.classList.remove("disabled");                
            }

            if(showsubs && !isSeeking) {
                if((subtitleEndTime && player.currentTime > subtitleEndTime) || (subtitleStartTime && player.currentTime < subtitleStartTime)) {
                    subtitleEndTime = undefined;
                    subtitleStartTime  = undefined;
                    subtitle.innerText = '';  
                }
            }

            // forward disable handling
            if(currentTime == duration) {
                forward.classList.add("disabled");
            } else {
                forward.classList.remove("disabled");                
            }

        });

        function closeVideoSettingsHandler (event) {
            var clickedInsideSettings = settingContainer.contains(event.target);
            if (!clickedInsideSettings) {
                showSettings = true;
                openSettings.click();
            }
        }

        function keyboardEventHandler (event){
            if(event.keyCode === 27){
                exitFullscreenButton.click();
                showSettings = true;
                openSettings.click();
            }
        }

        document.addEventListener('click',(event)=>{
           closeVideoSettingsHandler(event)
        });
        
        document.addEventListener('keydown',(event)=>{
            keyboardEventHandler(event)
        });

        enterFullscreenButton.addEventListener('click', function() {
            isFullscreen = true;

            enterFullscreenButton.classList.add('hide');
            exitFullscreenButton.classList.remove('hide');

            overlayContainer.classList.add('video-fullscreen-entered');
            videoContainer.classList.add('video-fullscreen-entered');
            horizontalDragger.classList.add('video-fullscreen-entered');
            transcriptContainer.classList.add('video-fullscreen-entered');

			if(subtitle.classList.contains("subtitle-not-fullscreen")) {
                subtitle.classList.remove("subtitle-not-fullscreen");
                subtitle.classList.add("subtitle-fullscreen");
            }
            
            let sidebar = document.querySelector('.sidebar') || document.querySelector('.notes-wrapper') || document.querySelector('.dictionary-wrapper');
            if(sidebar && ( sidebar.classList.contains('notes-left') || sidebar.classList.contains('toc-left') || sidebar.classList.contains('dictionary-left') ) ) {
                overlayContainer.classList.add('sidebar-open-left');
            } else if( sidebar && ( sidebar.classList.contains('notes-right') || sidebar.classList.contains('toc-right') || sidebar.classList.contains('dictionary-right') ) ) {
                overlayContainer.classList.add('sidebar-open-right');
            }


        });

        exitFullscreenButton.addEventListener('click', function() {
            isFullscreen = false;

            exitFullscreenButton.classList.add('hide');
            enterFullscreenButton.classList.remove('hide');

            overlayContainer.classList.remove('video-fullscreen-entered');
            overlayContainer.classList.remove('sidebar-open-right');
            overlayContainer.classList.remove('sidebar-open-left');
            videoContainer.classList.remove('video-fullscreen-entered');
            horizontalDragger.classList.remove('video-fullscreen-entered');
            transcriptContainer.classList.remove('video-fullscreen-entered');

            if(subtitle.classList.contains("subtitle-fullscreen")) {
                subtitle.classList.remove("subtitle-fullscreen");
                subtitle.classList.add("subtitle-not-fullscreen");
            }

            if(!isFullscreen) {
                let videoContainerBoundingRect = videoContainer.getBoundingClientRect();
                let contentContainerBoundingRect = contentContainer.getBoundingClientRect();
                
                if(videoContainerBoundingRect.left < contentContainerBoundingRect.left) {
                    position.x += (contentContainerBoundingRect.left - videoContainerBoundingRect.left );
                }else if(videoContainerBoundingRect.right > contentContainerBoundingRect.right) {
                    position.x -= (videoContainerBoundingRect.right - contentContainerBoundingRect.right);
                }
                videoContainer.style.transform = "translate("+position.x+"px, "+position.y+"px)";
            }

        });

        if(!isFullscreen && player) {
            enterFullscreenButton.click();
        }


        /************************************************************************************************* */
        /*************************************VIDEO Transcripts Start ************************************ */
        /************************************************************************************************* */
        
        player.on('seeking', function(){
            isSeeking = true;
        });
        player.on('seeked', function() {
            isSeeking = false;
        });

        var tracks, trackElems;

        trackElems = document.querySelectorAll("track");
        tracks = transcript.textTracks;
        if(!isTranscriptInitialized) initTranscript(tracks);
        
        function initTranscript(tracks1) {
            let lang = "en";
            // Locate the track with language = lang
            for(let i = 0; i < tracks1.length; i++) {
                // current track
                var track = tracks1[i];
                var trackAsHtmlElem = trackElems[i];
            
                if((track.language === lang) && (track.kind !== "chapters")) {
                    track.mode="showing";
                
                    if(trackAsHtmlElem.readyState === 2) {
                        // the track has already been loaded
                        displayCues(track);
                    } else {
                        displayCuesAfterTrackLoaded(trackAsHtmlElem, track);
                    }
                
                }
            } 
            isTranscriptInitialized = true;
        }

        function displayCuesAfterTrackLoaded(trackElem, track) {
            // Create a listener that will be called only when the track has
            // been loaded
            trackElem.addEventListener('load', function(e) {
                displayCues(track);
            });
        }
            
        function displayCues(track) {
            var cues = track.cues;
            var n = cues.length;
            var i;
            //append all the subtitle texts to 
            for(i=0; i<n; i++) {
                var cue = cues[i];
                cue.id = cue.id || "video-cue-" + i;
                cue.qid = cue.qid || i+1;
                cue.timeStampValue = cue.startTime + 0.2;
                addCueListeners(cue);
                

                //to check if the cue is karoake or not
                if(!cue.text.match(REforTimestamp)){
                    cue.timeStamp = false;
                    //html text
                    var transText = "";
                    transText = cue.text;
                    cueArray[cue.id] = cue.text;
                } else {
                    cue.timeStamp = true;
                    //html text and add span
                    var transText = "";
                    cueArray[cue.id] = cue.text;
                    transText = addSpan(cue.text);

                    var timeStampArray = [];
                    timeStampArray = addArray(cue.text);
                    timestampObject[cue.id] = timeStampArray;
                }
        
                var clickableTransText = "<a class='cues' qid='vid-cue-" + cue.qid +"' id=" + cue.id +  "  onclick='jumpTo(" + cue.startTime + ");'" + ">" + transText + "</a>";
                addToTranscriptDiv(clickableTransText);
            }
        }

        function addArray(text) {
            let result = [];
            let split = text.split(REforTimestamp);
            for (let i = 0; i < split.length; i++) {
                if (!!split[i].match(REforTimestamp)) {
                    let a = split[i].substring(1, split[i].length - 1);
                    let b = a.split(':');
                    let c = (b[0] * 60 * 60) + (+(b[1] * 60)) + (+b[2]);
                    if (b.length == 2) {
                        c = (+(b[0] * 60)) + (+b[1]);
                    }
                    result.push(c);
                }
            }
            return result;
        }

        function addSpan(text) {
            let index = 0;
            let result = "";
            let splitText = text.split(REforTimestamp);
            for (let i = 0; i < splitText.length; i++) {
                if (!splitText[i].match(REforTimestamp)) {
                    result += "<span class=" + index + ">" + splitText[i] + "</span>";
                    index++;
                }
            }
            if (result == "") {
                result = text;
            }
            return result;
        }

        document.getElementById('video-player').textTracks[0]?.addEventListener('cuechange', function() {
            if (showsubs && this.activeCues && this.activeCues.length && this.activeCues[0]) {
                subtitle.style.display = 'block';
                subtitleContainer.style.display = 'block';
            } else {
                subtitleContainer.style.display = 'none';
                subtitle.style.display = 'none';
            }
            if(this.activeCues && this.activeCues.length && this.activeCues[0] && this.activeCues[0].text) {


                var subText = '';
                
                for(var i=0; i<Object.keys(cueArray).length; i++) {
                    if(this.activeCues[0].id === Object.keys(cueArray)[i]) {
                        subText = cueArray[Object.keys(cueArray)[i]];
                    }
                }
                var text = addSpan(subText);
                text = text.replace(REforHTMLTags, function (wholeMatch, tagName) {
                    if (AllowedTags[tagName.toLowerCase()]) {
                        return wholeMatch;
                    } else {
                        return "";
                    }
                });
                subtitle.innerHTML = text;
                subtitleEndTime = this.activeCues[0].endTime;
                subtitleStartTime = this.activeCues[0].startTime;
                currentCue = this.activeCues[0];
            }
        });

        function jumpTo(time) {
            transcript.currentTime = time;
        }

        window.jumpTo = jumpTo;
        
        function addToTranscriptDiv(htmlText) {
            htmlText = htmlText.replace(REforHTMLTags, function (wholeMatch, tagName) {
                if (AllowedTags[tagName.toLowerCase()]) {
                    return wholeMatch;
                } else {
                    return "";
                }
            });
            transcriptSection.innerHTML += htmlText;
        }
        
        function addCueListeners(cue) {

                cue.onenter = function() {
                    var activeTranscript = document.getElementById(this.id);
                    if(activeTranscript) {
                        transcriptSection.scrollTop = activeTranscript.offsetTop - 80 - document.querySelector('.transcript-container').offsetTop;
                        activeTranscript.classList.add("current");
                    }
                };
            
                cue.onexit = function() {
                    var activeTranscript = document.getElementById(this.id);
                    if(activeTranscript) {
                        activeTranscript.classList.remove("current");
                    }  
                };
        }
    

        /************************************************************************************************* */
        /********************************VIDEO Transcripts End ******************************************* */
        /************************************************************************************************* */


        /*              **************************************                 */
        /*                  Video Subtitle Handling Starts                     */
        /*              **************************************                 */
        subtitleButton.addEventListener( 'click' , function () {
            toggleSubtitles();
        });

        function toggleSubtitles() {
            if(options.jsonData.type!="video") {

                showsubs = !showsubs;
                if(!showsubs) {
                    subtitle.style.display = 'none';
                    subtitleContainer.style.display = 'none';
                    subtitleButton.classList.remove('active');
                } else {
                    subtitleButton.classList.add('active');
                }
            }
        }

        player.on('enterfullscreen', function() {
            
            if(subtitleSection.classList.contains("subtitle-section-not-fullscreen")) {
                subtitleSection.classList.remove("subtitle-section-not-fullscreen");
                subtitleSection.classList.add("subtitle-section-fullscreen");
            }
            if(subtitle.classList.contains("subtitle-not-fullscreen")) {
                subtitle.classList.remove("subtitle-not-fullscreen");
                subtitle.classList.add("subtitle-fullscreen");
            }

            if(showsubs) {
                plyrCaptions.style.width = (video.clientWidth - 20) + 'px';
                plyrCaptions.style.left = ((plyrContainer.offsetWidth - plyrCaptions.offsetWidth) / 2) + 'px';
            }
            _disableTranscriptAndSubtitles(options.jsonData.type);
            // document.querySelector(".draggable").style.display = "none";
        });

        player.on('exitfullscreen', function() {
            
            if(subtitleSection.classList.contains("subtitle-section-fullscreen")) {
                subtitleSection.classList.remove("subtitle-section-fullscreen");
                subtitleSection.classList.add("subtitle-section-not-fullscreen");
            }
            
            if(subtitle.classList.contains("subtitle-fullscreen")) {
                subtitle.classList.remove("subtitle-fullscreen");
                subtitle.classList.add("subtitle-not-fullscreen");
            }
            
            if(showsubs) {
                setTimeout(function() {
                    plyrCaptions.style.width = (video.clientWidth - 20) + 'px';
                    plyrCaptions.style.left = ((plyrContainer.offsetWidth - plyrCaptions.offsetWidth) / 2) + 'px';
                });
            }
            toggleTranscript(false);
            _disableTranscriptAndSubtitles(options.jsonData.type);

            // document.querySelector(".draggable").style.display = "block";

        });

        /*              **************************************                 */
        /*                  Video Subtitle Handling Endsv                      */
        /*              **************************************                 */

        //android phone will autorotate to landscape mode when in fullscreen mode 
        document.addEventListener('fullscreenchange', function() {
            if (document.fullscreenElement) {
                if(navigator.userAgent.match(/Android/i)){
                    window.screen.orientation.lock('landscape');
                    setTimeout(function(){
                        window.screen.orientation.unlock();
                    },2000);
                } 
            }
            _disableTranscriptAndSubtitles(options.jsonData.type);
        });
        
        orientationChangeEventListener = function() {
            _disableTranscriptAndSubtitles(options.jsonData.type);
            if(document.querySelector('.video-container') == null) {
                return;
            }

            position.x = 0;
            position.y = 0;
            let scaleX = window.getComputedStyle(document.querySelector('.video-container')).transform == 'none' ? 1 : window.getComputedStyle(document.querySelector('.video-container')).transform.match(/-?\d+\.?\d*/g)[0];
            videoContainer.style.transform = "scale("+scaleX+") translate("+position.x+"px, "+position.y+"px)";
        }

        window.addEventListener("orientationchange", orientationChangeEventListener);
        
        resizeEventListener = function() {
            
            if(this.window.innerWidth <= 1024) {
                if(!isFullscreen && player) {
                    enterFullscreenButton.click();
                }
                reduceTranscriptsSize();
            }
            removeTranscriptPosition();
            setTranscriptPosition();

            if (this.window.innerWidth > 576) {
                let sidebar = document.querySelector('.sidebar') || document.querySelector('.notes-wrapper');
                if(sidebar && ( sidebar.classList.contains('notes-left') || sidebar.classList.contains('toc-left') ) ) {
                    overlayContainer.classList.add('sidebar-open-left');
                } else if( sidebar && ( sidebar.classList.contains('notes-right') || sidebar.classList.contains('toc-right') ) ) {
                    overlayContainer.classList.add('sidebar-open-right');
                }
            } else {
                overlayContainer.classList.remove('sidebar-open-right');
                overlayContainer.classList.remove('sidebar-open-left');
            }

        }

        window.addEventListener("resize", resizeEventListener);

        // #333 : Selection Deletion feature not working properly with Audio\Video 

        overlayContainer.removeAllListeners();
        overlayContainer.addEventListener('mouseup', function(e) {
            let evt = document.createEvent('HTMLEvents');
            evt.initEvent('mouseup', false, true);
            let imagebookWrapper = document.querySelector('#imgbook_wrapper');
            imagebookWrapper && imagebookWrapper.dispatchEvent(evt);
        });

        overlayContainer.addEventListener('toc-open-event', function(event) {

            const tocWidth = 320;

            let outerContainer = document.querySelector('.outer-container');
            let isContentScrollable = Math.abs(outerContainer.offsetWidth - outerContainer.scrollWidth) > 1 ? true : false;

            let videoContainerBoundingRect = videoContainer.getBoundingClientRect();
            let contentContainerBoundingRect = contentContainer.getBoundingClientRect();


            if(isContentScrollable) {

                if(event.detail.tocPosition == 'left') {
                
                    if(videoContainerBoundingRect.right > contentContainerBoundingRect.right) {
                        position.x -= (videoContainerBoundingRect.right - contentContainerBoundingRect.right);
                    } else {

                        if(videoContainerBoundingRect.right + tocWidth/2 > contentContainerBoundingRect.right) {
                            position.x += Math.abs(videoContainerBoundingRect.right - contentContainerBoundingRect.right);
                        } else {
                            position.x += tocWidth/2;
                        }

                    }
                    videoContainer.style.transform = "translate("+position.x+"px, "+position.y+"px)";
                    
                } else if(event.detail.tocPosition == 'right') {
                
                    if(videoContainerBoundingRect.left < contentContainerBoundingRect.left) {
                        position.x += (contentContainerBoundingRect.left - videoContainerBoundingRect.left);
                    } else {
                        if(videoContainerBoundingRect.left - tocWidth/2 < contentContainerBoundingRect.left) {
                            position.x -= Math.abs(videoContainerBoundingRect.left - contentContainerBoundingRect.left);
                        } else {
                            position.x -= tocWidth/2;
                        }
                    }
                    videoContainer.style.transform = "translate("+position.x+"px, "+position.y+"px)";
    
                }

            } else {

                if(videoContainerBoundingRect.right > contentContainerBoundingRect.right) {
                    position.x -= (videoContainerBoundingRect.right - contentContainerBoundingRect.right);
                }else if(videoContainerBoundingRect.left < contentContainerBoundingRect.left) {
                    position.x += (contentContainerBoundingRect.left - videoContainerBoundingRect.left );
                }
                videoContainer.style.transform = "translate("+position.x+"px, "+position.y+"px)";
                    
            }


        });

        overlayContainer.addEventListener('toc-close-event', function(event) {
            
            const tocWidth = 320;

            let videoContainerBoundingRect = videoContainer.getBoundingClientRect();
            let contentContainerBoundingRect = contentContainer.getBoundingClientRect();

            if(event.detail.wasContentScrollable) {

                if(event.detail.lastTocPosition == 'left') {

                    if(videoContainerBoundingRect.right + tocWidth/2 >= contentContainerBoundingRect.right) {
                        // empty if block
                        // requirements changed
                    } else {
                        position.x -= tocWidth/2;
                    }
                    videoContainer.style.transform = "translate("+position.x+"px, "+position.y+"px)";
                    
                } else if(event.detail.lastTocPosition == 'right') {

                    if(videoContainerBoundingRect.left - tocWidth/2 <= contentContainerBoundingRect.left) {
                        // empty if block
                        // requirements changed
                    } else {
                        position.x += tocWidth/2;
                    }
                    videoContainer.style.transform = "translate("+position.x+"px, "+position.y+"px)";

                }

            }

            contentContainerBoundingRect = contentContainer.getBoundingClientRect();
            videoContainerBoundingRect = videoContainer.getBoundingClientRect();

            if(videoContainerBoundingRect.left < contentContainerBoundingRect.left) {
                position.x += (contentContainerBoundingRect.left - videoContainerBoundingRect.left );
            }
            if(videoContainerBoundingRect.right > contentContainerBoundingRect.right) {
                position.x -= (videoContainerBoundingRect.right - contentContainerBoundingRect.right);
            }
            videoContainer.style.transform = "translate("+position.x+"px, "+position.y+"px)";

            overlayContainer.classList.remove('sidebar-open-right');
            overlayContainer.classList.remove('sidebar-open-left');

        });

        // ******************************************************************** //
        // *** Handling for show hide controls while on transcripts starts **** //
        // ******************************************************************** //

        /*
        *   Plyr give events fired when controls are shown or hidder. also gives a function to toggle he controls to show or hide.
        *   Whenever we touch or click or mousemove on videocontainer, we store the timestamp. after 2 seconds we fire the hide controls.
        *   This is controlled by a 2 sec debouncer.
        *   When hide event is recieved and the time is less than 2 secs, we fire the function to show controls as there is no prevent default.
        */


        videoContainer.addEventListener('mousemove', videoHideControlsListener);
        videoContainer.addEventListener('click', videoHideControlsListener);
        videoContainer.addEventListener('touchstart', videoHideControlsListener);

        function videoHideControlsListener() {

            lastHideControlsTime = Date.now();
            player.toggleControls(true);

            setTimeout(function() {
                let t = Date.now();
                if(t - lastHideControlsTime > 1900 && player.ready && !player.ended && !player.paused && !player.stopped) {
                    player.toggleControls(false);
                }
            },2000);

        }

        player.on('controlshidden', function(event) {
            let t = Date.now();
            if(t - lastHideControlsTime < 1900 && player.ready && !player.ended && !player.paused && !player.stopped) {
                player.toggleControls(true);
            } else {
                player.toggleControls(false);
            }
        });


        // ******************************************************************** //
        // ***** Handling for show hide controls while on transcripts ends **** //
        // ******************************************************************** //
        
        
        // disable subtitle and transcipt for hotspot type =="video"
        _disableTranscriptAndSubtitles(options.jsonData.type);       

        player.speed = 1;

        dlsVideoPlayer.player = player;
        dlsVideoPlayer.options = options;

        // document.querySelector('#videoSource').addEventListener('error', (err) => {

        //     if(closeAndReopen) {
        //         return;
        //     }

        //     if(dlsVideoPlayer.player) {
        //         closePlayer.click();
        //     }

        //     let t = Date.now();
        //     console.log(t - timeAtLaunch);
        //     if( t - timeAtLaunch <= 500) {
                
        //         // $('#assetErrorModal').attr('missing','audio');
                
        //         if(options.events.navigateToDashboard) {
        //             options.events.navigateToDashboard();
        //         }
        //         $('#assetErrorModal').modal('show');
        //     }
        // });

    }

    function _disableTranscriptAndSubtitles(type) {
        let subtitleButton = document.getElementById("subs");
        let transcriptButton = document.getElementById("transcript");


        if(type=="video") {
            
            if(!subtitleButton.classList.contains('disabled')) 
                subtitleButton.classList.add("disabled");
            subtitleButton.style.cursor = "default";
            
            if(!transcriptButton.classList.contains('disabled')) 
                transcriptButton.classList.add("disabled");
            transcriptButton.style.cursor = "default";
            
        } else {
            if(subtitleButton) {
                if(subtitleButton.classList.contains('disabled')) 
                    subtitleButton.classList.remove("disabled");
                subtitleButton.style.cursor = "";
            }
            
            if(transcriptButton) {
                if(transcriptButton.classList.contains('disabled')) 
                    transcriptButton.classList.remove("disabled");
                transcriptButton.style.cursor = "";
            }
            
        } 
    }

    function destroyPlayer(closeAndReopenPlyr) {
        let video = document.querySelector('#video-player');
        if (video) {
            let videoSrc = document.querySelector('#video-player').querySelector('source');
            video.pause();
            video.src = "";
            video.removeAttribute('src');
            videoSrc.src = "";
            videoSrc.removeAttribute('src');
            video.load();
        }

        var overlayContainer = document.querySelector('.overlay-container');
        if(overlayContainer){
            overlayContainer.classList.remove('mobile-video-player');
            overlayContainer.classList.remove('video-fullscreen-entered');
            overlayContainer.classList.remove('sidebar-open-right');
            overlayContainer.classList.remove('sidebar-open-left');
            overlayContainer.innerHTML = "";
            overlayContainer.style.display = 'none';
        }
        dlsVideoPlayer.player = undefined;
        if(dlsVideoPlayer.options.onClose){
            dlsVideoPlayer.options.onClose(closeAndReopenPlyr);
        }
        dlsVideoPlayer.player.destroy();
        window.removeEventListener("orientationchange", orientationChangeEventListener);
        window.removeEventListener("resize", resizeEventListener);
        document.removeEventListener("click", closeVideoSettingsHandler);
        document.removeEventListener("keydown", keyboardEventHandler);

       
    }

    window.dlsVideoPlayer = {
        "launchPlayer" : launchPlayer,
        "destroyPlayer": destroyPlayer,
        "player" : undefined
    };

})();